// extracted by mini-css-extract-plugin
module.exports = {"info":"_event__info__NkKtb","carousel":"_event__carousel__XCMkY","internalCarousel":"_event__internalCarousel__aTMWc"};